module.exports = __webpack_public_path__ + "static/video-f2e307870788c0ab13b0dae0ca1e0dfe.mp4";